<template>
<transition name="modal">
    <div id="modal-mcq">
        <div class="modal-mask">
            <div class="modal-wrapper">
                <div class="modal-container p-0 mcq-modal">
                    <!-- http://www.alpach.com/permisecole/qcm/?ligth=0&theme=coderoute&mode=serie -->
                    <!-- <iframe :src="`/qcm/launch?ligth=0&theme=coderoute&mode=serie&filename=${filename}&product_id=${product_id}`"> -->
                    <iframe :src="`/qcm/launch?theme=coderoute&mode=serie&filename=${$route.params.filename}&product_id=${$route.params.productId}&themes=${$route.params.themes}`" style="border:0" allowfullscreen="allowfullscreen">
                        <p>Votre navigateur ne supporte pas les iframes.</p>
                    </iframe>
                    <!-- IFRAME :
                    <pre>$route.params.id: {{ $route.params.id }}</pre>
                    <pre>$route.params: {{ $route.params }}</pre>
                    <pre>$route.query: {{ $route.query }}</pre> -->
                </div>
            </div>
        </div>
    </div>
</transition>
</template>

<script>
export default {
    name: 'mcq-modal',
    props: [],
    created: function() {
        // console.error('McqModal.vue created');
        // $('body').css('overflow', 'hidden');
        // window.addEventListener('keyup', this.close);
        //
        // setInterval(function() {
        // 	var body = document.body,
        // 	    html = document.documentElement,
        // 		w = Math.max(body.scrollWidth, body.offsetWidth, html.clientWidth, html.scrollWidth, html.offsetWidth),
        // 		h = Math.max(body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight);
        // 	$('#arf').html(
        // 		'bsh:' + body.scrollHeight + ', ' +
        // 		'bh:' + body.offsetHeight + ', ' +
        // 		'hch:' + html.clientHeight + ', ' +
        // 		'hsh:' + html.scrollHeight + ', ' +
        // 		'hoh:' + html.offsetHeight
        // 	);
        // }, 200);
    },
    mounted() {
        // console.error('McqModal.vue mounted');
        // console.error('mcq-modal', window.dataLayer, window.gtag);

        // if (/free/.test(window.location.hash)) {
        //     $('#modal-mcq').css({'margin-top': 48});
        // }
        //
        // window.gtag('event', 'qcm', {
        //     'event_category': 'open',
        //     'event_label': window.location.hash
        // });

        window.openQcm();

    },
    methods: {
        close(e) {
            // if (e.which == 27) {
            //     if ($('.modal-mask').is(':visible')) {
            //         $('body').css('overflow', 'auto');
            //         this.$router.go(-1);
            //     }
            // }
        }
    }
}
</script>


<style>
body {
    /* @see quitQcm && openQcm */
    /* overflow: hidden; */
}

.modal-mask {
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    margin: auto;
    background-color: rgba(0, 0, 0, .5);
    display: table;
    transition: opacity .3s ease;
}

.modal-wrapper {
    display: table-cell;
    vertical-align: middle;
}

/* https://github.com/ampproject/amphtml/issues/11133 */
.modal-container.mcq-modal {
    position: fixed;/* Usefull for the MCQ */
    z-index: 9998;
    width: 100%;
    height: 100%; /* Usefull for the MCQ */
    top: 0;
    left: 0;
    background-color: #fff;
    color: #fff;
    box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
    transition: all .3s ease;
    overflow: hidden;

    -webkit-overflow-scrolling: touch !important;
}

.modal-container.mcq-modal iframe {
    height: 0;
    max-height: 100%;
    max-width: 100%;
    min-height: 100%;
    min-width: 100%;
    width: 0;
    border: 0;
}

/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.modal-enter {
    opacity: 0;
}

.modal-leave-active {
    opacity: 0;
}

.modal-enter .modal-container.mcq-modal,
.modal-leave-active .modal-container.mcq-modal {
    -webkit-transform: scale(1.1);
    transform: scale(1.1);
}
</style>
